import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { history } from '../../_helpers';
import { setToast } from '../../store/ToastManagement';
import { useForm } from '../../_helpers/hooks/form';
import { useCurrentUser } from '../../_services';
import {
  Grid,
  Container,
  Button,
  Form,
  Header,
  Label
} from 'semantic-ui-react';

const ResetPassword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userId = params.get('user');
  const token = params.get('auth');

  const { resetForgottenPassword } = useCurrentUser();

  const dispatch = useDispatch();
  const displaySuccess = () =>
    dispatch(
      setToast({
        title: 'Success!',
        body: 'Password was successfully reset.'
      })
    );

  const handleSubmit = React.useCallback(
    async values => {
      await resetForgottenPassword(userId, values.password, token);
      history.push(`/login`);
    },
    [resetForgottenPassword, userId, token]
  );

  const {
    values,
    onFieldChange,
    onFieldBlur,
    onSubmit,
    error,
    fieldHasError,
    didSucceed,
    errors,
    resetForm
  } = useForm({
    initialValues: {
      password: '',
      confirm: ''
    },
    onSubmit: handleSubmit,
    validators: {
      password: [
        ({ password }) =>
          password.length < 10 && 'Must be at least 10 characters'
      ],
      confirm: [
        ({ password, confirm: confirmPw }) =>
          password !== confirmPw && 'Passwords must match'
      ]
    }
  });

  React.useEffect(() => {
    if (didSucceed) {
      resetForm();
      displaySuccess();
    }
  }, [didSucceed, resetForm]); // eslint-disable-line

  const createOnChangeHandler = field => (_, { value }) =>
    onFieldChange(field, value);

  return (
    <div>
      <Container>
        <Grid centered padded textAlign="center" style={{ height: '90vh' }}>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h2" textAlign="left" style={{ color: 'white' }}>
              Password Reset
            </Header>
            <Form onSubmit={onSubmit}>
              {error && (
                <Label basic color={'red'} className={'red'}>
                  {error}
                </Label>
              )}
              <Form.Field>
                <Form.Input
                  label="New Password"
                  type="password"
                  icon="lock"
                  iconPosition="left"
                  placeholder="Must be at least 10 characters"
                  onChange={createOnChangeHandler('password')}
                  value={values.password}
                  onBlur={() => onFieldBlur('password')}
                  error={fieldHasError('password') && errors.password}
                />
              </Form.Field>

              <Form.Field error={fieldHasError('confirm')}>
                <Form.Input
                  label="Confirm New Password"
                  type="password"
                  icon="lock"
                  iconPosition="left"
                  placeholder="Enter the same password"
                  onChange={createOnChangeHandler('confirm')}
                  value={values.confirm}
                  onBlur={() => onFieldBlur('confirm')}
                  error={fieldHasError('confirm') && errors.confirm}
                />
              </Form.Field>

              <Button type="submit" color="olive">
                Change Password
              </Button>
            </Form>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

export { ResetPassword };
